export const ur3 = {
  'images': [],
  'mainFeatures': [
    'Nano Graphite Coating with Premium Nature Rubber.',
    'Patented Multi-functional Mounting Base & Adapters.',
  ],
  'material': [
    'Rubber: Premium Nature Rubber.',
    'Steel: SGCC, Electrostatic Powder Coating.',
    'Plastic: Spacer & Adapter: POM',
    'Stainless Steel Backing: SUS304ES',
  ],
  'featureIcons': ["02", "03", "08", "10"],
  'otherFeatures': ['01', '02'],
  'specification': [
    { "inch": "8", "mm": "200", "width": "6", "thickness": "0.7" },
    { "inch": "10", "mm": "250", "width": "6", "thickness": "0.7" },
    { "inch": "12", "mm": "300", "width": "6", "thickness": "0.7" },
    { "inch": "14", "mm": "350", "width": "6", "thickness": "0.7" },
    { "inch": "16", "mm": "400", "width": "6", "thickness": "0.7" }
  ],
  'adapters': ["r0-ur3", "r1a-ur3", "r2-ur3", "r3-ur3", "r4-ur3", "r5-ur3", "r6-ur3", "ra-ur3", "rb-ur3", "rc-ur3", "rd-ur3", "rd+-ur3", "re-ur3", "rec-ur3", "rg-ur3",]
}